import { render, staticRenderFns } from "./edit-feedback-modal.vue?vue&type=template&id=67591b80"
import script from "./edit-feedback-modal.vue?vue&type=script&lang=js"
export * from "./edit-feedback-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports